module.exports = __webpack_public_path__ + "static/media/download.43d1d7ec.svg";